import { supabase } from './supabase'
import { fetchProfiles } from './profileCache'

// Friends' daily results, one place (2026-10-18): the Games lane and the curtain
// both read it. own-or-following RLS on the three results tables does the gating.
export async function friendsResults(ids, days) {
  if (!ids?.length) return []
  const [c, f, v] = await Promise.all([
    supabase.from('cliffhanger_results').select('user_id, day, won, points, clues_used, created_at').in('day', days).in('user_id', ids),
    supabase.from('faceoff_results').select('user_id, day, score, points, created_at').in('day', days).in('user_id', ids),
    supabase.from('verdict_results').select('user_id, day, score, created_at').in('day', days).in('user_id', ids),
  ])
  const out = []
  for (const r of c.data || []) out.push({ key: 'cliffhanger', user_id: r.user_id, day: r.day, at: r.created_at, score: r.won ? r.points : 0, short: r.won ? `${r.points} pts` : 'no solve', detail: r.won ? `solved in ${r.clues_used || '?'} clue${r.clues_used === 1 ? '' : 's'} · ${r.points} pts` : 'ran out of guesses' })
  for (const r of f.data || []) out.push({ key: 'faceoff', user_id: r.user_id, day: r.day, at: r.created_at, score: r.score, short: `${r.score}/5`, detail: `scored ${r.score}/5` })
  for (const r of v.data || []) out.push({ key: 'verdict', user_id: r.user_id, day: r.day, at: r.created_at, score: r.score, short: `${r.score}/100`, detail: `landed ${r.score}/100` })
  const pm = await fetchProfiles([...new Set(out.map(o => o.user_id))])
  return out.map(o => ({ ...o, profile: pm[o.user_id] || null })).sort((a, b) => new Date(b.at) - new Date(a.at))
}
export const profileName = (p) => p ? (p.display_name || p.username || 'Someone') : 'Someone'
